export function isUSAPostal(postal: string) {
  const regex = /^\d{5}([-]?\d{4})?$/;

  return regex.test(postal);
}
